import React from 'react';
import { Autocomplete, TextField } from '@mui/material';

import { countryName } from '../../contacts/contactList';
import { ISO_COUNTRY_CODES } from '../../contacts/countries';

const label = (code: string) => `${countryName(code)} (${code})`;

/** A country by name, sent as its two-letter code. Empty clears it. */
export const CountryField = ({
  value,
  onChange,
  label: fieldLabel = 'Country',
  error,
  helperText,
}: {
  value: string;
  onChange: (code: string) => void;
  label?: string;
  error?: boolean;
  helperText?: string;
}) => (
  <Autocomplete
    options={ISO_COUNTRY_CODES as Array<string>}
    value={value ? value.toUpperCase() : null}
    onChange={(_, code) => onChange(code ?? '')}
    getOptionLabel={label}
    autoHighlight
    size="small"
    renderInput={(params) => <TextField {...params} label={fieldLabel} error={error} helperText={helperText} />}
  />
);
